/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyFollowUpNotificationPatternRegistrableTypename =
  "PharmacyFollowUpNotificationPatternRegistrable" as const;

/**
 *
 * @export
 * @interface PharmacyFollowUpNotificationPatternRegistrable
 */
export interface PharmacyFollowUpNotificationPatternRegistrable {
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  messageTemplate: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  notificationDays?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  notificationTime?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  orderNumber?: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  questionnairePatternId?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  sendMethod?: PharmacyFollowUpNotificationPatternRegistrableSendMethodEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyFollowUpNotificationPatternRegistrable
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyFollowUpNotificationPatternRegistrableSendMethodEnum {
  Sms = "sms",
  Line = "line",
  App = "app",
}

export function PharmacyFollowUpNotificationPatternRegistrableFromJSON(
  json: any
): PharmacyFollowUpNotificationPatternRegistrable {
  return PharmacyFollowUpNotificationPatternRegistrableFromJSONTyped(json, false);
}

export function PharmacyFollowUpNotificationPatternRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyFollowUpNotificationPatternRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyFollowUpNotificationPatternRegistrableTypename,

    messageTemplate: json["message_template"],
    name: json["name"],
    notificationDays: !exists(json, "notification_days") ? undefined : json["notification_days"],
    notificationTime: !exists(json, "notification_time") ? undefined : json["notification_time"],
    orderNumber: !exists(json, "order_number") ? undefined : json["order_number"],
    questionnairePatternId: !exists(json, "questionnaire_pattern_id") ? undefined : json["questionnaire_pattern_id"],
    sendMethod: !exists(json, "send_method") ? undefined : json["send_method"],
  };
}

export function PharmacyFollowUpNotificationPatternRegistrableToJSON(
  object?: PharmacyFollowUpNotificationPatternRegistrable | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    message_template: value.messageTemplate,
    name: value.name,
    notification_days: value.notificationDays,
    notification_time: value.notificationTime,
    order_number: value.orderNumber,
    questionnaire_pattern_id: value.questionnairePatternId,
    send_method: value.sendMethod,
  };
}
